import { PageWithNavigation } from '@/src/components';
import { PageHeader } from '@/src/pages/AnytimeEligibilityV2/components/PageHeader';
import { SkeletonCard } from '@/src/components/SkeletonLoading/SkeletonCard';
import React from 'react';

export const Loading = ({ title = '' }: { title?: string }) => {
  return (
    <PageWithNavigation title="EV Charge Anytime - Eligibility">
      <PageHeader
        title={title}
        showDescription={false}
        testId="loading-header"
      />
      <SkeletonCard data-testid="loading-screen" />
    </PageWithNavigation>
  );
};
